import React from 'react';

const XML_EXAMPLE = `<?xml version="1.0" encoding="UTF-8"?>
<recall lang="MANDATORY" xmlns="urn:recall-schema">
  <edit_type>I</edit_type>
  <id>MANDATORY</id>
  <country_id>MANDATORY</country_id>
  <manufacturer>OPTIONAL : REMOVE THE NODE IF EMPTY</manufacturer>
  <manufacturer_country_id>OPTIONAL : REMOVE THE NODE IF EMPTY</manufacturer_country_id>
  <product_type>OPTIONAL : REMOVE THE NODE IF EMPTY</product_type>
  <product_name>MANDATORY</product_name>
  <product_desc>OPTIONAL : REMOVE THE NODE IF EMPTY</product_desc>
  <product_code>OPTIONAL : REMOVE THE NODE IF NO PRODUCT CODE
    <publication>MANDATORY</publication>
    <segment>OPTIONAL AND REPEATABLE : REMOVE THE SUBNODE IF EMPTY</segment>
    <family>OPTIONAL AND REPEATABLE : REMOVE THE SUBNODE IF EMPTY</family>
    <class>OPTIONAL AND REPEATABLE : REMOVE THE SUBNODE IF EMPTY</class>
    <brick>OPTIONAL AND REPEATABLE : REMOVE THE SUBNODE IF EMPTY</brick>
  </product_code>
  <product_model_no>OPTIONAL : REMOVE THE NODE IF EMPTY</product_model_no>
  <hazard>OPTIONAL : REMOVE THE NODE IF EMPTY</hazard>
  <injuries>OPTIONAL : REMOVE THE NODE IF EMPTY</injuries>
  <action>OPTIONAL : REMOVE THE NODE IF EMPTY</action>
  <units>OPTIONAL : REMOVE THE NODE IF EMPTY</units>
  <URL>OPTIONAL : REMOVE THE NODE IF EMPTY</URL>
  <date>MANDATORY</date>
  <GTIN>OPTIONAL : REMOVE THE NODE IF EMPTY</GTIN>
  <GTIN_product_type>OPTIONAL : REMOVE THE NODE IF EMPTY</GTIN_product_type>
  <GTIN_desc>OPTIONAL : REMOVE THE NODE IF EMPTY</GTIN_desc>
  <HTS>OPTIONAL : REMOVE THE NODE IF EMPTY</HTS>
  <HTS_product_type>OPTIONAL : REMOVE THE NODE IF EMPTY</HTS_product_type>
  <HTS_desc>OPTIONAL : REMOVE THE NODE IF EMPTY</HTS_desc>
  <image> OPTIONAL AND REPEATABLE : REMOVE THE NODE IF NO IMAGE
    <filename>MANDATORY</filename>
    <media_type>MANDATORY</media_type>
    <alt_text>MANDATORY</alt_text>
  </image>
  <manufacturer_website>OPTIONAL : REMOVE THE NODE IF EMPTY</manufacturer_website>
</recall>
`;

const TYPE = `<edit_type>I</edit_type>`;

const Template = () => {
  return (
    <div>
      <h4>
        Upload a new recall
      </h4>
      <p className="pt-callout pt-intent-warning pt-icon-info-sign">
        <strong>Important:</strong> When uploading a new recall, use the command <strong>{TYPE}</strong> in your XML
        file.
      </p>
      <pre>
        <code className="language-xml">
          {XML_EXAMPLE}
        </code>
      </pre>
    </div>
  )
};

export default Template;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/xml-format/empty-structures/structure-template-new.js